module.exports = "https://pm2019.reeltime.no/public/images/bg.3ea580c4.png";